import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from '../../../../../../common/react/utils/translations';

const getLeadingScore = (home, away, homeScore, awayScore) => {
    let obj = {
        home: {},
        away: {},
        draw: false
    };

    if (homeScore > awayScore) {
        obj = {
            team: home.team,
            score: homeScore - awayScore
        };
    } else if (homeScore < awayScore) {
        obj = {
            team: away.team,
            score: awayScore - homeScore
        };
    } else if (homeScore === awayScore && homeScore > 0) {
        obj = {
            draw: true
        };
    }

    return obj;
};

export const FixtureSummary = ({ home, away, isLive = false }) => {
    const leaderObj = getLeadingScore(
        home,
        away,
        home.liveScore ? home.liveScore : home.score?.totalScore,
        away.liveScore ? away.liveScore : away.score?.totalScore
    );

    if (leaderObj.draw) {
        return (
            <div className="fixtures__match-summary">
                {isLive
                    ? getTranslation('label.fixtures.drawText')
                    : getTranslation('label.fixtures.drawTextEnded')}
            </div>
        );
    }

    if (leaderObj && leaderObj.score) {
        return (
            <div className="fixtures__match-summary">
                {isLive ? (
                    <>
                        {`${leaderObj.team.name} ${getTranslation(
                            'label.fixtures.leadBy'
                        )} ${leaderObj.score}`}
                    </>
                ) : (
                    <>
                        {`${leaderObj.team.name} ${getTranslation(
                            'label.fixtures.wonBy'
                        )} ${leaderObj.score}`}
                    </>
                )}
            </div>
        );
    }

    return <></>;
};

FixtureSummary.propTypes = {
    home: PropTypes.object,
    away: PropTypes.object,
    isLive: PropTypes.bool
};
